import { Outlet } from "react-router-dom";

export default function Discover() {
  return <Outlet />;
}
